import { render } from "./HandlingUnitTable.vue?vue&type=template&id=6fb84f98"
import script from "./HandlingUnitTable.vue?vue&type=script&lang=js"
export * from "./HandlingUnitTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__